<template>
  <div class="fixed z-[9999] inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <transition name="showUp" appear>
        <div class="fixed inset-0 bg-black bg-opacity-25 transition-opacity" aria-hidden="true"></div>
      </transition>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

      <transition name="comeIn" appear>
      <div class="inline-block align-bottom bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full sm:mx-0 sm:h-10 sm:w-10" :class="isDanger ? 'bg-red-100' : 'bg-neutral-100'">
              <!-- Heroicon name: outline/exclamation -->
              <svg class="h-6 w-6" :class="isDanger ? 'text-red-600' : 'text-neutral-600'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-neutral-900" id="modal-title">{{this.title}}</h3>
              <div class="mt-2">
                <p class="text-sm text-neutral-600">{{ this.message }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-white px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button v-if="isDanger" type="button" class="w-full inline-flex justify-center rounded-lg border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm" @click.prevent="$emit('done')">{{this.buttonText}}</button>
          <button v-else type="button" class="w-full inline-flex justify-center rounded-lg border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white hover:brightness-95 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm" style="background-color: var(--accent-color)" @click.prevent="$emit('done')">{{this.buttonText}}</button>
          <button type="button" class="mt-3 w-full inline-flex justify-center rounded-lg border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-neutral-800 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" @click.prevent="$emit('cancel')">{{ cancelText || $t("Cancel") }}</button>
        </div>
      </div>
      </transition>
    </div>
  </div>
</template>
<script>

export default {

 props: {
   title: String,
   message: String,
   buttonText: String,
   cancelText: String,
   // "danger" for anything that can't be undone; "neutral" for reversible confirms.
   tone: { type: String, default: "danger" },
 },
 computed: {
   isDanger() {
     return this.tone !== "neutral";
   },
 },
  data: function () {
    return {

    };
  },
}
</script>

<style scoped>
.showUp-enter-active,
.showUp-leave-active {
  transition: opacity 200ms cubic-bezier(0.165, 0.84, 0.44, 1);
}

.showUp-enter,
.showUp-leave-to {
  opacity: 0;
}

.showUp-leave,
.showUp-enter-to {
  opacity: 1;
}

.comeIn-enter-active,
.comeIn-leave-active {
  transition: opacity 200ms cubic-bezier(0.165, 0.84, 0.44, 1),
              transform 200ms cubic-bezier(0.165, 0.84, 0.44, 1);
}

.comeIn-enter,
.comeIn-leave-to {
  opacity: 0;
  transform: translateY(16px) scale(0.98);
}

.comeIn-leave,
.comeIn-enter-to {
  opacity: 1;
  transform: translateY(0) scale(1);
}
</style>
